




import Vue from 'vue'
import { RouteConfig } from 'vue-router'

interface Props {
  title: string
  to: Partial<RouteConfig>
}

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    title: {
      required: true,
    },
    to: {
      required: true,
    },
  },
})
